// extracted by mini-css-extract-plugin
export default {"list":"styles_list__o0uPr","item":"styles_item__P28sH","index":"styles_index__KpD-q","ordered":"styles_ordered__TrtVc","unordered":"styles_unordered__LBnoY"};